import { Injectable } from '@angular/core';
import { HttpService } from '@sdbn/appclient';
import { Observable } from 'rxjs';
import { Smartphone } from '../model/smartphone';
import { environment } from 'src/environments/environment';
import { Identity } from '@sdbn/appclient';
import { SmartphoneDetails } from '../model/smartphone-details';
import { ServiceResponse } from '@sdbn/appclient';

@Injectable({
    providedIn: 'root'
  })
  export class SmartphoneService {

    constructor(private tmcHttpService: HttpService) { }

    getSmartphones(): Observable<Smartphone[]> {
      return this.tmcHttpService.postWithContext<Smartphone[]>(environment.smartphoneAdminEndpoint, {});
    }

    getSmartphoneDetails(identity: Identity): Observable<SmartphoneDetails> {
      return this.tmcHttpService.postWithContext<SmartphoneDetails>(environment.smartphoneAdminEndpoint + '/details', identity);
    }

    saveSmartphone(smartphone: SmartphoneDetails): Observable<ServiceResponse> {
      return this.tmcHttpService.postWithContext<ServiceResponse>(environment.smartphoneAdminEndpoint + '/save', smartphone);
    }

    createSmartphone(smartphone: SmartphoneDetails): Observable<ServiceResponse> {
      return this.tmcHttpService.postWithContext<ServiceResponse>(environment.smartphoneAdminEndpoint + '/create', smartphone);
    }

    deleteSmartphone(identity: Identity): Observable<ServiceResponse> {
      return this.tmcHttpService.postWithContext<ServiceResponse>(environment.smartphoneAdminEndpoint + '/delete', identity);
    }
  }
